module.exports = __webpack_public_path__ + "static/media/calendar.8876c803.svg";